export default __webpack_public_path__ + "canvas-logo.png";